module.exports = __webpack_public_path__ + "img/img_logo.af4f14e0.png";